import { defineStyle as e, defineStyleConfig as i } from "@chakra-ui/styled-system";
const o = e({
  fontSize: "md",
  marginEnd: "3",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}), t = {
  solid: e({
    color: "onSurface.highEmphasis"
  }),
  subtle: e({
    color: "onSurface.lowEmphasis"
  })
}, n = {
  md: e({
    // might need a `mb` instead of relying on the wrapping stack spacing
    fontSize: "lg",
    fontWeight: "medium",
    lineHeight: "6",
    letterSpacing: "normal"
  }),
  sm: e({
    // might need a `mb` instead of relying on the wrapping stack spacing
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "5",
    letterSpacing: "normal"
  })
}, m = i({
  baseStyle: o,
  sizes: n,
  variants: t,
  defaultProps: {
    size: "sm",
    variant: "solid"
  }
});
export {
  m as formLabelTheme
};
